// Maximum time of RTM response is 15 seconds, but API Team recommended to use 20 seconds
export const DEFAULT_RESPONSE_TIMEOUT = 20 * 1000;
